import { render } from "./feedBackOk.vue?vue&type=template&id=222c6b40&scoped=true"
const script = {}

import "./feedBackOk.vue?vue&type=style&index=0&id=222c6b40&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222c6b40"]])

export default __exports__